import { OrderStatus } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { Order } from "@ticketingplatform/api/dist/order/fragments/__generated__/Order";
import { UseTableQueryParamsOptions } from "hooks/useTableQueryParams/types";

export const DEFAULT_TABLE_PARAMS: UseTableQueryParamsOptions<Order> = {
  defaultValue: {
    pageSize: 10,
    filters: {
      status: [OrderStatus.COMPLETED],
    },
    sorter: [
      {
        columnKey: "createdAt",
        order: "descend",
      },
    ],
  },
};
